import type { Locale } from "@mesketch/i18n";

/** Kořen `/` vede na `/cs/`, když prohlížeč preferuje češtinu, jinak na `/en/` (REQ-017). */
export function preferredLocale(languages: readonly string[]): Locale {
  const first = languages[0]?.toLowerCase() ?? "";
  return first === "cs" || first.startsWith("cs-") ? "cs" : "en";
}
